// resources/js/app.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the configured router
import store from './store/index.js'; // Import your Vuex store
import Shimmer from 'vue3-shimmer';
import { createHead } from '@vueuse/head';

// Bootstrap CSS + JS stay global: they power the shared shell (Header offcanvas,
// dropdowns, collapse) that appears on every page.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// PERFORMANCE: jQuery, Select2, Summernote and vue-tel-input are deliberately NOT
// imported globally anymore. They are large and only used on a handful of pages, so
// each is imported locally inside the component that needs it:
//   - vue-tel-input        -> components/Add_Business.vue
//   - Select2 (+ jQuery)   -> components/Add_Business.vue, components/Business-list.vue
//   - Summernote (+ jQuery)-> business_dashboard/support-ticket/{add_support,view_support}.vue
// Combined with route-level code splitting (routes.js), this keeps the home / shared
// bundle small so FCP, LCP, TBT and Speed Index stay fast.

const app = createApp(App);
const head = createHead(); // Create an instance of createHead

app.use(store); // Install Vuex store
app.use(router);
app.use(Shimmer);
app.use(head);

// Mount only once the initial route (and its lazy-loaded chunk) is ready.
// Otherwise the first Vue frame is just Header + Footer with an empty
// <router-view> — the footer paints near the top and then gets pushed down
// when the route component arrives (a ~0.2 CLS hit on server-rendered pages).
// Until then the server-rendered HTML stays visible, so nothing flashes.
router.isReady()
    .catch(() => {})
    .then(() => app.mount('#app'));
